import { createCrudActions } from '../utils/crudGenerator';

const formatProducts = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchProducts,
    create: createProduct,
    update: updateProduct,
    delete: deleteProducts
} = createCrudActions('PRODUCT', "Producto", formatProducts);